import { NavigationContainer, DefaultTheme, DarkTheme } from "@react-navigation/native";
import * as React from "react";
import { ColorSchemeName, useColorScheme } from "react-native";
import * as Linking from "expo-linking";
import RootStackNavigator from "./SharedNavigator/RootNavigator/RootStackNavigator";
import LinkingConfiguration from "./LinkingConfiguration";
import { setItemInSessionStorage } from "../services/utils/storageService";
import { useSelector } from "react-redux";
import { lightColors, darkColors } from "../utils/constants/colors";

export default function Navigation({
  colorScheme,
}: {
  colorScheme: ColorSchemeName;
}) {
  const themeMode = useSelector((s: any) => s.configurations.themeMode ?? "system");
  const systemScheme = useColorScheme();

  const isDark =
    themeMode === "dark" ||
    (themeMode === "system" && systemScheme === "dark");

  const customDarkTheme = {
    ...DarkTheme,
    colors: {
      ...DarkTheme.colors,
      background: darkColors.background,
      card: darkColors.background, 
      text: darkColors.text,
      border: darkColors.border,
      primary: darkColors.primary,
    },
  };

  const customDefaultTheme = {
    ...DefaultTheme,
    colors: {
      ...DefaultTheme.colors,
      background: lightColors.background,
      card: lightColors.surface, 
      text: lightColors.text,
      border: lightColors.border,
      primary: lightColors.primary,
    },
  };

  Linking.getInitialURL().then((data) => {
    if (data && data.includes("invites/")) {
      setItemInSessionStorage("invite-context", data);
    }
  });

  return (
    <NavigationContainer
      linking={LinkingConfiguration}
      theme={isDark ? customDarkTheme : customDefaultTheme}
    >
      <RootStackNavigator />
    </NavigationContainer>
  );
}
